import React from 'react';
import { Coffee, Handshake, User, Plus, Trash, ArrowLeft } from '@phosphor-icons/react';

export const ChatSidebar = ({ channels, activeChannel, onSwitchChannel, onShowNewPrivate, onDeleteConversation, isMobile, onClose }) => {
  const publicChannels = channels.filter(c => c.type === 'public');
  const privateChannels = channels.filter(c => c.type === 'private');

  return (
    <div data-testid="chat-sidebar" style={{
      width: isMobile ? '100%' : '240px',
      flexShrink: 0,
      borderRight: isMobile ? 'none' : '1px solid #E2E2E6',
      backgroundColor: '#FAFAFA',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden'
    }}>
      {isMobile && (
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #E2E2E6', fontWeight: '700', fontSize: '1.1rem', color: '#0A0B10' }}>
          Conversations
        </div>
      )}

      {/* Public channels */}
      <div style={{ padding: '14px 14px 8px', fontWeight: '700', fontSize: '0.72rem', color: '#9E9E9E', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Canaux
      </div>
      {publicChannels.map(ch => {
        const active = activeChannel === ch.id;
        return (
          <button key={ch.id} onClick={() => onSwitchChannel(ch.id)} data-testid={`channel-${ch.id}`}
            style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: isMobile ? '14px 16px' : '10px 14px',
              border: 'none', cursor: 'pointer',
              backgroundColor: active ? '#E3F2FD' : 'transparent',
              borderLeft: `3px solid ${active ? '#1565C0' : 'transparent'}`,
              color: active ? '#1565C0' : '#37474F',
              fontWeight: active ? '700' : '500',
              fontSize: isMobile ? '0.95rem' : '0.88rem',
              width: '100%', textAlign: 'left',
              transition: 'background-color 0.15s'
            }}>
            {ch.id === 'detente' ? <Coffee size={18} weight={active ? 'fill' : 'regular'} /> : <Handshake size={18} weight={active ? 'fill' : 'regular'} />}
            {ch.name}
          </button>
        );
      })}

      {/* Private channels */}
      <div style={{ padding: '14px 14px 8px', borderTop: '1px solid #E2E2E6', marginTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: '700', fontSize: '0.72rem', color: '#9E9E9E', textTransform: 'uppercase', letterSpacing: '1px' }}>Messages prives</span>
        <button onClick={onShowNewPrivate} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1565C0', padding: '4px' }} data-testid="new-private-btn">
          <Plus size={18} weight="bold" />
        </button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {privateChannels.length === 0 && (
          <div style={{ padding: '16px', textAlign: 'center', color: '#9E9E9E', fontSize: '0.8rem' }}>Aucune conversation</div>
        )}
        {privateChannels.map(ch => {
          const active = activeChannel === ch.id;
          return (
            <div key={ch.id} style={{ display: 'flex', alignItems: 'center' }}>
              <button onClick={() => onSwitchChannel(ch.id)} data-testid={`channel-${ch.id}`}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: isMobile ? '14px 16px' : '10px 14px',
                  border: 'none', cursor: 'pointer',
                  backgroundColor: active ? '#F3E5F5' : 'transparent',
                  borderLeft: `3px solid ${active ? '#6A1B9A' : 'transparent'}`,
                  color: active ? '#6A1B9A' : '#37474F',
                  fontWeight: active ? '700' : '500',
                  fontSize: isMobile ? '0.95rem' : '0.88rem',
                  flex: 1, textAlign: 'left'
                }}>
                <User size={18} weight={active ? 'fill' : 'regular'} /> {ch.name}
              </button>
              <button onClick={(e) => onDeleteConversation(ch.id, e)} data-testid={`delete-conv-${ch.id}`}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', color: '#BDBDBD', flexShrink: 0 }}>
                <Trash size={14} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
